import { buildBillingContext } from '@/apiCalls/billingContext';
import { postUrl } from '@/apiCalls/fetch';
import { EVehicleAssetType } from '@/context/borrower';
import { IModelApiResults } from '@/context/display';
import { getGlassAssetType } from '@/utils/glassGuideHelpers';

export async function getModel(
    partner: string,
    year: number | undefined,
    make: string | undefined,
    assetType?: EVehicleAssetType
): Promise<IModelApiResults[]> {
    const url = `/api/asset/select/${partner}/${getGlassAssetType(assetType)}/${year}/${make}`;
    return postUrl<IModelApiResults[]>(url, { billingContext: buildBillingContext() });
}
